import React from "react";
import { motion } from "framer-motion";

const CustomTable = ({ columns, rows }) => {
  const rowAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.4 },
    }),
  };

  return (
    <div className="">
      {/* Table Header */}
      <div className="flex font-bold bg-[#DEDEFF] text-gray-700 rounded-[24px] p-4 gap-4 mb-1">
        {columns.map((column) => (
          <div
            key={column.key}
            className="flex-1 w-full flex p-2 bg-[#F0F0FF] rounded-[14px] text-center justify-center items-center"
            style={{ flex: column.defaultFlex || 1 }}
          >
            {column.title}
          </div>
        ))}
      </div>
      {/* Table Rows */}
      <div className="bg-[#DEDEFF] rounded-[24px] p-4 text-[12px] flex flex-col gap-4">
        {rows.map((row, index) => (
          <motion.div
            key={row.id}
            custom={index}
            variants={rowAnimation}
            initial="hidden"
            animate="visible"
            className="flex-1 flex bg-[#DEDEFF] gap-4 text-center h-full"
          >
            {columns.map((column) => (
              <motion.div
                key={column.key}
                whileHover={{
                  scale: 1.05,
                  backgroundColor: "#fff",
                  boxShadow: "0px 0px 10px 1px rgba(0,0,0,0.1)",
                }}
                className="flex-1 flex flex-col items-center justify-center bg-[#F0F0FF] font-bold rounded-[14px] p-2 text-gray-700"
                style={{ flex: column.defaultFlex || 1 }}
              >
                {Array.isArray(row[column.dataIndex]) ? (
                  row[column.dataIndex].map((item, index) => (
                    <div key={index} className="px-4 py-2">
                      <span>
                        {item}
                        <br />
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2">{row[column.dataIndex]}</div>
                )}
              </motion.div>
            ))}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CustomTable;
